
	        <div class="min-h-screen bg-[color:var(--background)] text-[color:var(--foreground)] pt-4 sm:pt-6 pb-16 px-4">
	            <div class="max-w-7xl w-full mx-auto space-y-6">
	                <div class="space-y-2">
	                    <h1 class="text-4xl sm:text-5xl font-bold text-[color:var(--foreground)]">Property Listings</h1>
	                    <p class="text-lg text-[color:var(--muted-foreground)]">Discover your perfect property</p>
	                </div>
	
	                <!-- Search + Filters -->
                    <div class="relative">
                        <div #filterSentinel aria-hidden="true" class="h-px w-full"></div>
	                        <div
	                            #filterCard
	                            class="sticky z-40 mb-6 p-0 space-y-0"
                                [appStableStickyFilter]="isStickyCompact"
	                            [style.overflow-anchor]="'none'"
	                            [style.top.px]="stickyTopOffsetPx"
	                        >
	                    <div class="bg-white border border-slate-200 rounded-2xl shadow-md"
                             [class.rounded-t-none]="isFilterStuck" [class.border-t-0]="isFilterStuck"
                        >
                        <div class="p-4 lg:p-5" [ngClass]="isStickyCompact ? 'space-y-2' : 'space-y-4'">
	                        <div *ngIf="!isStickyCompact" class="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-4">
	                            <div class="flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-4 py-3 flex-1">
	                                <lucide-icon name="search" class="h-5 w-5 text-[color:var(--text-subtle)]"></lucide-icon>
	                                <input
	                                    type="text"
	                                    [(ngModel)]="filters.search"
	                                    (ngModelChange)="onFiltersChange()"
	                                    placeholder="Search by unit number, title, location, or keywords..."
	                                    class="w-full bg-transparent text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:outline-none"
	                                />
	                            </div>
                            <button
                                type="button"
                                (click)="toggleFilters()"
                                class="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 hover:bg-slate-100 text-sm font-semibold text-slate-700 transition-colors"
                            >
                                <lucide-icon name="filter" class="h-4 w-4 text-slate-700"></lucide-icon>
                                <span>{{ showFilters ? 'Hide filters' : 'More filters' }}</span>
                            </button>
                        </div>

                        <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                            <div class="flex flex-nowrap items-center gap-2 overflow-x-auto lg:flex-wrap lg:overflow-visible">
                                <button
                                    *ngIf="isStickyCompact"
                                    type="button"
                                    (click)="toggleFilters()"
                                    class="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-colors"
                                >
                                    <lucide-icon name="sliders-horizontal" class="h-4 w-4"></lucide-icon>
                                </button>
                                <div class="min-w-[12rem]">
	                                <app-country-selector [(ngModel)]="filters.country" (ngModelChange)="onFiltersChange()"></app-country-selector>
	                            </div>
                                <select
                                    [(ngModel)]="filters.projectId"
                                    (change)="onFiltersChange()"
                                    class="min-w-[12rem] text-sm font-semibold text-slate-900 focus:outline-none focus:border-[color:var(--ring)]"
                                    [ngClass]="isStickyCompact ? 'h-10 rounded-full bg-white border border-slate-200 px-4' : 'h-11 rounded-xl bg-white border border-slate-200 px-3'"
                                >
                                    <option value="">{{ projectsLoading ? 'Loading projects…' : 'Any project' }}</option>
                                    <option *ngFor="let project of projectsForFilter" [value]="project.id">{{ project.name }}</option>
                                </select>
                            <select
                                [(ngModel)]="filters.status"
                                (change)="onFiltersChange()"
                                class="text-sm font-semibold text-slate-900 focus:outline-none focus:border-[color:var(--ring)]"
                                [ngClass]="isStickyCompact ? 'h-10 rounded-full bg-white border border-slate-200 px-4' : 'h-11 rounded-xl bg-white border border-slate-200 px-3'"
                            >
                                <option value="any">Any status</option>
                                <option value="available">Available</option>
                                <option value="reserved">Reserved</option>
                                <option value="sold">Sold</option>
                            </select>

                            <select
                                [(ngModel)]="filters.sortBy"
                                (change)="onFiltersChange()"
                                class="text-sm font-semibold text-slate-900 focus:outline-none focus:border-[color:var(--ring)]"
                                [ngClass]="isStickyCompact ? 'h-10 rounded-full bg-white border border-slate-200 px-4' : 'h-11 rounded-xl bg-white border border-slate-200 px-3'"
                            >
                                <option value="recent">Newest</option>
                                <option value="price-low">Price: Low to High</option>
                                <option value="price-high">Price: High to Low</option>
                                <option value="ppsqm-low">Price / m²: Low to High</option>
                                <option value="ppsqm-high">Price / m²: High to Low</option>
                            </select>

                            <select
                                [(ngModel)]="filters.propertyType"
                                (change)="onFiltersChange()"
                                class="text-sm font-semibold text-slate-900 focus:outline-none focus:border-[color:var(--ring)]"
                                [ngClass]="isStickyCompact ? 'h-10 rounded-full bg-white border border-slate-200 px-4' : 'h-11 rounded-xl bg-white border border-slate-200 px-3'"
                            >
                                <option *ngFor="let opt of propertyTypeOptions" [value]="opt.value">{{ opt.label }}</option>
                            </select>

	                            
	                        </div>

                        <div *ngIf="filters.projectId && filters.country" class="mt-2 text-xs text-slate-600">
                            Country filter is ignored when a project is selected.
                        </div>

                        <div *ngIf="!isStickyCompact" class="flex flex-wrap items-center justify-between gap-3 text-sm text-[color:var(--muted-foreground)] px-1">
                            <span>{{ resultsSummary() }}</span>
                        </div>
                    </div>
                    </div>
                    </div>

                    <ng-template #advancedFiltersFields>
                        <div class="flex items-center gap-1 rounded-xl border border-slate-200 bg-white p-1">
                            <button
                                type="button"
                                (click)="filterTab = 'general'"
                                class="flex-1 rounded-lg px-3 py-2 text-sm font-semibold transition"
                                [ngClass]="filterTab === 'general' ? 'bg-[color:var(--primary)] text-[color:var(--primary-foreground)]' : 'text-slate-700 hover:bg-slate-50'"
                            >
                                General
                            </button>
                            <button
                                type="button"
                                (click)="filterTab = 'location'"
                                class="flex-1 rounded-lg px-3 py-2 text-sm font-semibold transition"
                                [ngClass]="filterTab === 'location' ? 'bg-[color:var(--primary)] text-[color:var(--primary-foreground)]' : 'text-slate-700 hover:bg-slate-50'"
                            >
                                Location
                            </button>
                        </div>

                        <ng-container *ngIf="filterTab === 'general'; else locationTab">
                            <div class="flex flex-wrap gap-2">
                                <button
                                    *ngFor="let tag of availableTags"
                                    type="button"
                                    (click)="toggleTag(tag)"
                                    [ngClass]="filters.tags.includes(tag) ? 'bg-[color:var(--primary)] border-[color:var(--primary)] text-[color:var(--primary-foreground)]' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-100'"
                                    class="px-3 py-1.5 rounded-full border text-sm font-semibold transition-colors"
                                >
                                    + {{ tag }}
                                </button>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Bedrooms
                                    <select [(ngModel)]="filters.bedrooms" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option [ngValue]="null">Any</option>
                                        <option *ngFor="let bed of bedroomOptions" [ngValue]="bed">{{ bed }}</option>
                                    </select>
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Bathrooms
                                    <select [(ngModel)]="filters.bathrooms" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option [ngValue]="null">Any</option>
                                        <option *ngFor="let bath of bathroomOptions" [ngValue]="bath">{{ bath }}</option>
                                    </select>
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Status
                                    <select [(ngModel)]="filters.status" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option value="any">Any</option>
                                        <option value="available">Available</option>
                                        <option value="reserved">Reserved</option>
                                        <option value="sold">Sold</option>
                                    </select>
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Country
                                    <app-country-selector [(ngModel)]="filters.country" [disableAutoDetect]="true"></app-country-selector>
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Sort By
                                    <select [(ngModel)]="filters.sortBy" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option value="nearest">Nearest to me</option>
                                        <option value="price-low">Price: Low to High</option>
                                        <option value="price-high">Price: High to Low</option>
                                        <option value="ppsqm-low">Price / sqm: Low to High</option>
                                        <option value="ppsqm-high">Price / sqm: High to Low</option>
                                        <option value="recent">Newest</option>
                                        <option value="bedrooms">Bedrooms</option>
                                        <option value="bathrooms">Bathrooms</option>
                                        <option value="unit-type">Property Type</option>
                                        <option value="title">Alphabetical</option>
                                    </select>
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Min Price ({{ currencyService.currentCurrency() }})
                                    <input type="number" [(ngModel)]="filters.minPrice" (change)="onFiltersChange()" class="w-full rounded-lg bg-white border border-slate-200 text-slate-900 px-3 py-3 focus:outline-none focus:border-[#6e9bad]" placeholder="0" />
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Max Price ({{ currencyService.currentCurrency() }})
                                    <input type="number" [(ngModel)]="filters.maxPrice" (change)="onFiltersChange()" class="w-full rounded-lg bg-white border border-slate-200 text-slate-900 px-3 py-3 focus:outline-none focus:border-[#6e9bad]" placeholder="No limit" />
                                </label>
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Property Type
                                    <select [(ngModel)]="filters.propertyType" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option *ngFor="let opt of propertyTypeOptions" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </label>
                                <div class="flex flex-col text-sm text-slate-700 space-y-2 md:col-span-2 lg:col-span-4">
                                    <span>Features</span>
                                    <div class="flex flex-wrap gap-3">
                                        <label class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 hover:bg-slate-50">
                                            <input type="checkbox" [(ngModel)]="filters.featureGarden" (change)="onFiltersChange()" />
                                            Garden
                                        </label>
                                        <label class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 hover:bg-slate-50">
                                            <input type="checkbox" [(ngModel)]="filters.featureTerrace" (change)="onFiltersChange()" />
                                            Terrace
                                        </label>
                                        <label class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 hover:bg-slate-50">
                                            <input type="checkbox" [(ngModel)]="filters.featureGroundFloor" (change)="onFiltersChange()" />
                                            Ground floor
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #locationTab>
                            <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Location
                                    <input
                                        type="text"
                                        [(ngModel)]="filters.location"
                                        (change)="onFiltersChange()"
                                        class="w-full rounded-lg bg-white border border-slate-200 text-slate-900 px-3 py-3 focus:outline-none focus:border-[#6e9bad]"
                                        placeholder="City, area, or landmark..."
                                    />
                                </label>

                                <label class="flex flex-col text-sm text-slate-700 space-y-2">
                                    Project
                                    <select [(ngModel)]="filters.projectId" (change)="onFiltersChange()" class="bg-white border border-slate-200 text-slate-900 px-3 py-3 rounded-lg focus:outline-none focus:border-[#6e9bad]">
                                        <option value="">Any</option>
                                        <option *ngFor="let project of projectsForFilter" [value]="project.id">
                                            {{ project.name }}
                                        </option>
                                    </select>
                                    <span *ngIf="projectsLoading" class="text-xs text-slate-500">Loading projects…</span>
                                    <span *ngIf="!projectsLoading && projectsError" class="text-xs text-red-600">{{ projectsError }}</span>
                                </label>
                            </div>
                        </ng-template>
                    </ng-template>

			                    <div *ngIf="showFilters && !isMobileViewport" class="grid grid-cols-1 gap-3 bg-slate-50 border border-slate-200 rounded-xl p-4">
			                        <ng-container *ngTemplateOutlet="advancedFiltersFields"></ng-container>
			                    </div>
		                </div>

		                    <!-- Properties -->
		                    <ng-container *ngIf="!loading; else loadingTpl">
		                        <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
		                            <app-property-card *ngFor="let property of filteredProperties" [property]="property"></app-property-card>
	                        </div>

                        <div *ngIf="hasNextPage" class="mt-10 flex justify-center">
                            <button
                                type="button"
                                (click)="loadMore()"
                                [disabled]="loadingPage"
                                class="inline-flex items-center justify-center gap-2 rounded-full border border-[color:var(--border)] bg-[color:var(--card)] px-6 py-3 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60"
                            >
                                <lucide-icon [name]="loadingPage ? 'loader-2' : 'plus'" class="h-4 w-4" [class.animate-spin]="loadingPage"></lucide-icon>
                                {{ loadingPage ? 'Loading...' : 'Show more' }}
                            </button>
                        </div>

                        <div *ngIf="filteredProperties.length === 0" class="py-20 text-center">
                            <div class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full border border-slate-200 bg-white shadow-sm">
                                <lucide-icon name="search" class="h-10 w-10 text-slate-300"></lucide-icon>
                            </div>
                            <h3 class="mb-2 text-xl font-bold text-slate-900">
                                {{ filters.country && !filters.projectId ? 'No properties in this country' : 'No properties found' }}
                            </h3>
                            <p *ngIf="filters.country && !filters.projectId; else genericEmpty" class="text-slate-600">
                                There are no properties available in {{ filters.country | uppercase }} right now. You can browse other countries.
                            </p>
                            <ng-template #genericEmpty>
                                <p class="text-slate-600">Try adjusting your filters or check back later.</p>
                            </ng-template>

                            <div *ngIf="filters.country && !filters.projectId" class="mt-6 flex flex-wrap justify-center gap-3">
                                <button
                                    type="button"
                                    (click)="browseOtherCountries()"
                                    class="inline-flex items-center justify-center rounded-full bg-[color:var(--primary)] px-6 py-3 text-sm font-semibold text-[color:var(--primary-foreground)] transition hover:bg-[color:var(--primary-hover)]"
                                >
                                    Browse other countries
                                </button>
                            </div>
                        </div>
                    </ng-container>

	                    <ng-template #loadingTpl>
	                        <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
	                            <div *ngFor="let i of [0,1,2,3,4,5]" class="flex flex-col overflow-hidden rounded-[28px] border border-[color:var(--border)] bg-[color:var(--card)]">
	                                <div class="relative w-full aspect-video bg-slate-200 animate-pulse"></div>
	                                <div class="flex flex-1 flex-col p-6 gap-4">
	                                    <div class="space-y-3">
	                                        <div class="h-5 bg-slate-200 rounded animate-pulse w-3/4"></div>
	                                        <div class="space-y-1.5">
	                                            <div class="h-3 bg-slate-200 rounded animate-pulse w-1/4"></div>
	                                            <div class="h-3 bg-slate-200 rounded animate-pulse w-full"></div>
	                                            <div class="h-3 bg-slate-200 rounded animate-pulse w-5/6"></div>
	                                        </div>
	                                    </div>
	                                    <div class="mt-auto flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-[color:var(--border)] pt-3">
	                                        <div class="h-3 bg-slate-200 rounded animate-pulse w-12"></div>
	                                        <div class="h-3 bg-slate-200 rounded animate-pulse w-12"></div>
	                                        <div class="h-3 bg-slate-200 rounded animate-pulse w-16"></div>
	                                    </div>
	                                    <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--muted)] p-4 space-y-4 hidden sm:block">
	                                        <div class="h-3 bg-slate-200 rounded animate-pulse w-1/3"></div>
	                                        <div class="grid grid-cols-2 gap-3">
	                                            <div class="space-y-2">
	                                                <div class="h-3 bg-slate-200 rounded animate-pulse w-1/2"></div>
	                                                <div class="h-5 bg-slate-200 rounded animate-pulse w-3/4"></div>
	                                            </div>
	                                            <div class="space-y-2">
	                                                <div class="h-3 bg-slate-200 rounded animate-pulse w-1/2"></div>
	                                                <div class="h-5 bg-slate-200 rounded animate-pulse w-3/4"></div>
	                                            </div>
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </ng-template>
                    </div>
		        </div>
	        </div>

            <div
                *ngIf="showFilters && isMobileViewport"
                class="fixed inset-0 z-[100] flex items-end justify-center bg-black/40 backdrop-blur-sm p-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] sm:items-center sm:p-4"
            >
                <div class="flex w-full max-w-lg flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl max-h-[calc(100vh-1rem)] sm:max-h-[calc(100vh-2rem)]">
                    <div class="flex items-center justify-between border-b border-slate-200 px-4 py-3">
                        <p class="text-sm font-semibold text-slate-900">Filters</p>
                        <button type="button" (click)="closeFilters()" class="rounded-full bg-slate-100 p-2 text-slate-700 hover:bg-slate-200">
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>
                    <div class="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4">
                        <div class="grid grid-cols-1 gap-3">
                            <ng-container *ngTemplateOutlet="advancedFiltersFields"></ng-container>
                        </div>
                    </div>
                    <div class="border-t border-slate-200 p-4">
                        <button type="button" (click)="closeFilters()" class="w-full rounded-lg bg-[color:var(--primary)] px-4 py-3 text-sm font-semibold text-[color:var(--primary-foreground)] transition-colors hover:bg-[color:var(--primary-hover)]">
                            Apply filters
                        </button>
                    </div>
                </div>
            </div>
	    
